import { ClientDeliveryAddress, DeliveryAddress } from 'interfaces';

export const parseClientDeliveryAddressIntoDeliveryAddress: (
   clientDeliveryAddress: ClientDeliveryAddress,
) => DeliveryAddress = clientDeliveryAddress => clientDeliveryAddress.address;
